// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__pYi2O","col":"CardReaderDesc_col__3ZCBc","label":"CardReaderDesc_label__1YwQd"};